export default __webpack_public_path__ + "assets/AVN-dark.svg";